import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	urlCaption: {
		id: 'navigation-shortcuts.common.messages.repo-messages.url-caption',
		defaultMessage: 'Repository link',
		description: '',
	},
	urlPlaceholder: {
		id: 'navigation-shortcuts.common.messages.repo-messages.url-placeholder',
		defaultMessage: 'e.g. https://bitbucket.org/org/projectrepository',
		description: '',
	},
	nameCaption: {
		id: 'navigation-shortcuts.common.messages.repo-messages.name-caption',
		defaultMessage: 'Name',
		description: '',
	},
	namePlaceholder: {
		id: 'navigation-shortcuts.common.messages.repo-messages.name-placeholder',
		defaultMessage: 'e.g. Project repository',
		description: '',
	},
	invalidUrlError: {
		id: 'navigation-shortcuts.common.messages.repo-messages.invalid-url-error',
		defaultMessage: 'Please enter a valid URL',
		description: '',
	},
});
